import axios from 'axios'
import { MONTHLY_COMMISSIONS_ENDPOINT } from '../../endpoints'

export async function getAllPeriods() {
  const response = await axios.get(
    `${MONTHLY_COMMISSIONS_ENDPOINT}/getAllPeriods`
  )
  return response.data.data
}
